import { useIndustriesQuery } from '@/modules/companies/queries/useIndustriesQuery';
import { MultiSelect } from '@/modules/ui/MultiSelect';

/** As many as finlay-api keeps: room for a family of industries, few enough to stay a preference. */
const MAX_INDUSTRIES = 10;

interface JobEmployerIndustriesFieldProps {
  value: string[];
  /** The value is the company's own industry, shown because nobody has picked any yet. */
  suggested?: boolean;
  onChange: (industries: string[]) => void;
  /** The form's help text style. */
  helpClassName: string;
}

/**
 * The industries the job's search prefers candidates' current employers to be in: Coresignal's names, searched as
 * the user types (partial words and missing letters still find them). It ranks, never filters: people at companies in
 * other industries, or of none known, still turn up, lower down. A new job starts with its company's own industry.
 */
export function JobEmployerIndustriesField({
  value,
  suggested = false,
  onChange,
  helpClassName,
}: JobEmployerIndustriesFieldProps) {
  const industriesQuery = useIndustriesQuery();
  const options = (industriesQuery.data ?? []).map((name) => ({
    value: name,
    label: name,
  }));

  return (
    <>
      <MultiSelect
        options={options}
        defaultValue={value}
        onValueChange={(picked) => onChange(picked.slice(0, MAX_INDUSTRIES))}
        placeholder={
          industriesQuery.isPending ? 'Loading industries…' : 'Any industry'
        }
        disabled={industriesQuery.isPending}
        hideSelectAll
        maxCount={4}
        className="h-auto min-h-9"
      />
      <p className={helpClassName}>
        {suggested && 'Suggested from the company’s industry. '}
        Finlay ranks people whose current company is in these industries higher,
        without leaving others out. Up to {MAX_INDUSTRIES}.
      </p>
    </>
  );
}
